import { gql, useMutation } from "@apollo/client";
import { PickupHubZipcodeType } from "../queries/pickupHubZipcode";

export interface PickupHubConfigInput {
    hubId: number;
    zipcodes: string[];
}

export const SAVE_OR_UPDATE_PICKUP_HUB_CONFIGS = gql`
    mutation SaveOrUpdatePickupHubConfigs($channelId: Long!, $configs: [PickupHubConfigInput!]!) {
        saveOrUpdatePickupHubConfigs(channelId: $channelId, configs: $configs) {
            hubId
            hubName
            zipcodes
        }
    }
`;

export const DELETE_PICKUP_HUB_CONFIG = gql`
    mutation DeletePickupHubConfig($channelId: Long!, $hubId: Long!) {
        deletePickupHubConfig(channelId: $channelId, hubId: $hubId)
    }
`;

export interface SaveOrUpdatePickupHubConfigsResponse {
    saveOrUpdatePickupHubConfigs: PickupHubZipcodeType[];
}

export interface SaveOrUpdatePickupHubConfigsVariables {
    channelId: number;
    configs: PickupHubConfigInput[];
}

export interface DeletePickupHubConfigResponse {
    deletePickupHubConfig: boolean;
}

export interface DeletePickupHubConfigVariables {
    channelId: number;
    hubId: number;
}

export const useSaveOrUpdatePickupHubConfigs = () => {
    return useMutation<SaveOrUpdatePickupHubConfigsResponse, SaveOrUpdatePickupHubConfigsVariables>(
        SAVE_OR_UPDATE_PICKUP_HUB_CONFIGS
    );
};

export const useDeletePickupHubConfig = () => {
    return useMutation<DeletePickupHubConfigResponse, DeletePickupHubConfigVariables>(
        DELETE_PICKUP_HUB_CONFIG
    );
};

